import { UnauthMasthead, UnauthMastheadProps } from "./unauth-masthead";

export default UnauthMasthead;
export type { UnauthMastheadProps };
